import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
} from "react-router-dom";
import {Box} from "@mui/material";
import {ThemeProvider} from "@mui/material/styles";
import {Header} from "./Header";
import {menuConfig} from "../components/menuConfig";
import {componentMap} from "../routing/componentMap";
import {CompareProvider} from "../components/catalogue/compare/CompareContext";
import theme from "../theme/theme";
import {CompareList} from "../components/catalogue/compare/CompareList";
import {CatalogueDetails} from "../components/catalogue/details/CatalogueDetails";
import {Favourites} from "../components/favourites/Favourites";
import {RoutesPath} from "../enums/RoutesPath";
import {PageNotFound} from "../routing/PageNotFound";
import {FavouritesProvider} from "../components/favourites/FavouritesContext";
import {Catalogue} from "../components/catalogue/Catalogue";
import {MotoGarageDetails} from "../components/garages/details/MotoGarageDetails";

const App: React.FC = () => {
    return (
        <ThemeProvider theme={theme}>
            <CompareProvider>
                <FavouritesProvider>
                    <Router>
                        <Box
                            sx={{
                                backgroundColor: theme.palette.websiteBackground.main,
                                p: 2,
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                boxSizing: "border-box",
                            }}
                        >
                            <Header/>
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                }}
                            >
                                <Routes>
                                    {menuConfig.map((menu) => {
                                        const Component = componentMap[menu.redirectUrl] || componentMap[RoutesPath.CATALOGUE];
                                        return (
                                            <Route
                                                key={menu.redirectUrl}
                                                path={menu.redirectUrl}
                                                element={<Component/>}
                                            />
                                        );
                                    })}
                                    <Route path={RoutesPath.CATALOGUE_DETAILS} element={<CatalogueDetails/>}/>
                                    <Route path={RoutesPath.MOTO_GARAGE_DETAILS} element={<MotoGarageDetails/>}/>
                                    <Route path={RoutesPath.CATALOGUE_COMPARE} element={<CompareList/>}/>
                                    <Route path={RoutesPath.FAVOURITES} element={<Favourites/>}/>
                                    <Route path="/" element={<Catalogue/>}/>
                                    <Route path="*" element={<PageNotFound/>}/>
                                </Routes>
                            </Box>
                        </Box>
                    </Router>
                </FavouritesProvider>
            </CompareProvider>
        </ThemeProvider>
    );
};

export default App;
